export default "__VITE_ASSET__ahiJPqQP__"